 import { Api } from '@/agiles/common';
import * as TaxCode from '@/tenant/models/Master/TaxCode';
 
 export class CalcUtil{

    public Round(value: number, digits: number, roundType: TaxCode.RoundTypes):number
    {
        var roundBase: number = 1;
        for (var i = 0; i < digits; i++) {
            roundBase *= 10;
        }

        if (roundType == TaxCode.RoundTypes.RoundMidpoint)
            return Math.round(value * roundBase) / roundBase;
        else
        {
            if (value < 0 ) roundBase *= -1;

            if (roundType == TaxCode.RoundTypes.RoundDown)
                return Math.floor(value * roundBase) / roundBase;
            else
                return Math.ceil(value * roundBase) / roundBase;
        }
    }

    public GetCurrecyDecimal(currencyCode: string, api: Api){
        const obj = api.currencies.filter(obj => obj.value == currencyCode);
        if (obj.length == 0) return 0;
        else return Number(obj[0].text);
    }
    public GetSystemCurrencyDecimal(api: Api) {
        const obj = api.currencies.filter(obj => obj.value == api.tenantSettings.currencyCode);
        if (obj.length == 0) return 0;
        else return Number(obj[0].text);        
    }
 }